import React, { useEffect, useState, useRef } from "react";
import Header from "../Components/Header";

const Video = () => {
    const [videoType, setVideoType] = useState("file"); // "file" or "youtube"
    const [videoFile, setVideoFile] = useState(null);
    const [videoPreview, setVideoPreview] = useState(null);
    const [youtubeLink, setYoutubeLink] = useState("");
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [adding, setAdding] = useState(false);
    const [deletingId, setDeletingId] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [error, setError] = useState(null);
    const fileInputRef = useRef(null);

    const fetchVideos = async () => {
        try {
            const res = await fetch('https://projects.sninfoserv.com/welb-api/home/get-videos/');
            const data = await res.json();
            console.log(data);
            if (data.status === "success") setVideos(data.data);
            else throw new Error("Failed to fetch videos");
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await fetchVideos();
            setLoading(false);
        };
        fetchData();
    }, []);

    const handleVideoFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setVideoFile(file);
            setVideoPreview(URL.createObjectURL(file));
        }
    };

    const handleTypeSwitch = (type) => {
        setVideoType(type);
        setVideoFile(null);
        setVideoPreview(null);
        setYoutubeLink("");
        setError(null);
        setSuccessMessage("");
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccessMessage("");

        if (videoType === "file" && !videoFile) {
            setError("Please select a video file");
            return;
        }
        if (videoType === "youtube" && !youtubeLink.trim()) {
            setError("Please enter a YouTube link");
            return;
        }

        setAdding(true);
        try {
            const formData = new FormData();
            formData.append("video_type", videoType);

            if (videoType === "file") {
                formData.append("video", videoFile);
            } else {
                formData.append("video_link", youtubeLink);
            }

            const response = await fetch('https://projects.sninfoserv.com/welb-api/admin/home/add-video/', {
                method: "POST",
                body: formData,
            });

            const data = await response.json();
            if (data.status === "success") {
                setSuccessMessage(
                    videoType === "file"
                        ? "Video uploaded successfully!"
                        : "YouTube video added successfully!"
                );
                await fetchVideos();
                setVideoFile(null);
                setVideoPreview(null);
                setYoutubeLink("");
                if (fileInputRef.current) fileInputRef.current.value = "";
            } else {
                throw new Error(data.message || "Failed to add video");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setAdding(false);
        }
    };

    const handleDelete = async (id) => {
        setDeletingId(id);
        setError(null);
        setSuccessMessage("");
        try {
            const response = await fetch('https://projects.sninfoserv.com/welb-api/home/delete-videos/', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id }),
            });
            const data = await response.json();
            if (data.status === "success") {
                setSuccessMessage("Video removed successfully!");
                setVideos((prev) => prev.filter((v) => v.id !== id));
            } else {
                throw new Error(data.message || "Failed to delete video");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setDeletingId(null);
        }
    };

    const getYoutubeEmbedUrl = (link) => {
        try {
            const url = new URL(link);
            let videoId = url.searchParams.get("v");
            if (!videoId) {
                videoId = url.pathname.split("/").pop();
            }
            return `https://www.youtube.com/embed/${videoId}`;
        } catch {
            return null;
        }
    };

    return (
        <>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">

                                {successMessage && (
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        {successMessage}
                                        <button type="button" className="btn-close" onClick={() => setSuccessMessage("")}></button>
                                    </div>
                                )}
                                {error && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        {error}
                                        <button type="button" className="btn-close" onClick={() => setError(null)}></button>
                                    </div>
                                )}

                                <div className="mb-3">
                                    <h5
                                        className="mb-0 fw-bold d-inline-block px-3 py-2 rounded"
                                        style={{
                                            fontSize: '30px',
                                            background: "linear-gradient(135deg, #0d6efd15, #0d6efd08)",
                                            borderLeft: "5px solid #0d6efd",
                                            color: "#0d6efd",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Add Video
                                    </h5>
                                </div>

                                <div className="d-flex gap-2 mb-4">
                                    <button
                                        type="button"
                                        className={`btn ${videoType === "file" ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => handleTypeSwitch("file")}
                                    >
                                        <i className="ti ti-video me-2"></i>
                                        Video Upload
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${videoType === "youtube" ? "btn-danger" : "btn-outline-danger"}`}
                                        onClick={() => handleTypeSwitch("youtube")}
                                    >
                                        <i className="ti ti-brand-youtube me-2"></i>
                                        YouTube Link
                                    </button>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="form-body">
                                        <div className="row align-items-end">


                                            {videoType === "file" && (
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label>Select Video File</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            accept="video/*"
                                                            ref={fileInputRef}
                                                            onChange={handleVideoFileChange}
                                                        />
                                                        {videoFile && (
                                                            <span className="badge bg-primary mt-1">
                                                                <i className="ti ti-check me-1"></i>
                                                                {videoFile.name}
                                                            </span>
                                                        )}

                                                        {videoPreview && (
                                                            <div className="mt-2 position-relative d-inline-block">
                                                                <video
                                                                    src={videoPreview}
                                                                    controls
                                                                    style={{
                                                                        width: "280px",
                                                                        height: "160px",
                                                                        borderRadius: "8px",
                                                                        border: "1px solid #dee2e6",
                                                                        display: "block",
                                                                        objectFit: "cover"
                                                                    }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-danger"
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-8px",
                                                                        right: "-8px",
                                                                        borderRadius: "50%",
                                                                        width: "22px",
                                                                        height: "22px",
                                                                        padding: "0",
                                                                        fontSize: "12px",
                                                                        lineHeight: "1"
                                                                    }}
                                                                    onClick={() => {
                                                                        setVideoFile(null);
                                                                        setVideoPreview(null);
                                                                        if (fileInputRef.current) fileInputRef.current.value = "";
                                                                    }}
                                                                >
                                                                    <i className="ti ti-x"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}


                                            {videoType === "youtube" && (
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label>YouTube Video Link</label>
                                                        <div className="input-group">
                                                            <span className="input-group-text bg-danger text-white">
                                                                <i className="ti ti-brand-youtube"></i>
                                                            </span>
                                                            <input
                                                                type="url"
                                                                className="form-control"
                                                                placeholder="https://www.youtube.com/watch?v=..."
                                                                value={youtubeLink}
                                                                onChange={(e) => setYoutubeLink(e.target.value)}
                                                            />
                                                        </div>

                                                        {youtubeLink && getYoutubeEmbedUrl(youtubeLink) && (
                                                            <div className="mt-2">
                                                                <iframe
                                                                    src={getYoutubeEmbedUrl(youtubeLink)}
                                                                    width="280"
                                                                    height="160"
                                                                    style={{
                                                                        borderRadius: "8px",
                                                                        border: "1px solid #dee2e6",
                                                                        display: "block"
                                                                    }}
                                                                    allowFullScreen
                                                                    title="YouTube Preview"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}


                                            <div className="col-md-2">
                                                <div className="mb-3">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-light-primary text-primary font-medium w-100"
                                                        disabled={adding}
                                                    >
                                                        {adding ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                                Adding…
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ti ti-plus me-1"></i> Add
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>

                                <hr />


                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                                    <h5 className="mb-0">Videos List</h5>
                                    <span className="badge bg-dark fs-6">
                                        {videos.length} {videos.length === 1 ? "Video" : "Videos"}
                                    </span>
                                </div>

                                <div className="table-responsive" style={{ overflowX: "auto" }}>
                                    <table className="table border table-striped table-bordered align-middle">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Type</th>
                                                <th>Preview</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4">
                                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                        Loading videos…
                                                    </td>
                                                </tr>
                                            ) : videos.length === 0 ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center fw-bold">
                                                        No videos added yet.
                                                    </td>
                                                </tr>
                                            ) : (
                                                videos.map((video, index) => (
                                                    <tr key={video.id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {video.video_type === "youtube" ? (
                                                                <span className="badge bg-danger">
                                                                    <i className="ti ti-brand-youtube me-1"></i>
                                                                    YouTube
                                                                </span>
                                                            ) : (
                                                                <span className="badge bg-primary">
                                                                    <i className="ti ti-video me-1"></i>
                                                                    Video File
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {video.video_type === "youtube" ? (
                                                                <iframe
                                                                    src={getYoutubeEmbedUrl(video.video_link)}
                                                                    width="160"
                                                                    height="90"
                                                                    style={{
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #dee2e6",
                                                                        display: "block"
                                                                    }}
                                                                    allowFullScreen
                                                                    title={`video-${index + 1}`}
                                                                />
                                                            ) : (
                                                                <video
                                                                    src={`https://projects.sninfoserv.com/welb-api/uploads/videos/${video.video_file}`}
                                                                    controls
                                                                    style={{
                                                                        width: "160px",
                                                                        height: "90px",
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #dee2e6",
                                                                        objectFit: "cover"
                                                                    }}
                                                                />
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="btn-group">
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => handleDelete(video.id)}
                                                                    disabled={deletingId === video.id}
                                                                >
                                                                    {deletingId === video.id ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                                            Removing…
                                                                        </>
                                                                    ) : (
                                                                        <i className="ti ti-trash"></i>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Video;